export enum OrgInfoSubscriptionType {
  FREE_ACCOUNT = 'free_account',
  STANDARD = 'standard',
  PREMIUM = 'premium',
  PLUS = 'plus', // New Standard
  TEAM = 'team', // New Plus
  BUSINESS = 'business',
  BUSINESS2023 = 'business2023',
  ALL_IN_ONE = 'allInOne',
  PLUS2024 = 'plus2024', // New Essential
  TEAM2024 = 'team2024', // New Plus
  BUSINESS2024 = 'business2024', // New Business
}
export interface OrgInfo {
  orgId: string;
  subscriptionType: OrgInfoSubscriptionType;
  subscriptionTypeSrc: string;
  type: string;
  isPremium: boolean;
  sub: string;
  domain: string;
  title: string;
  smallLogoStoredFileUUID: string | null;
  bigLogoStoredFileUUID: string | null;
  domainShorter: boolean;
  subscriptionPrivileges: string[];
  isShareAdEnabled: boolean;
}

export enum OrganizationPrivilege {
  CAN_GET_INFO = 'canGetInfo',
  CAN_ACCESS_WORKSPACES = 'canAccessWorkspaces',
  CAN_UPDATE_WORKSPACES = 'canUpdateWorkspaces',
  CAN_OCR = 'canOCR',
  CAN_ADD_MEMBERS = 'canAddMembers',
  CAN_UPDATE_MEMBERS = 'canUpdateMembers',
  CAN_DELETE_MEMBERS = 'canDeleteMembers',
  CAN_VIEW_MEMBERS = 'canViewMembers',
  CAN_VIEW_DISABLED_MEMBERS = 'canViewDisabledMembers',
  CAN_VIEW_INVITES = 'canViewInvites',
  CAN_ACCESS_ORG_PANEL = 'canAccessOrgPanel',
  CAN_MANAGE_WORKSPACES = 'canManageWorkspaces',
  CAN_MANAGE_ORG_LOGO = 'canManageOrgLogo',
  CAN_MANAGE_WORKSPACES_BRANDING = 'canManageWorkspacesBranding',
  CAN_MANAGE_CUSTOM_HTML_INTEGRATIONS = 'canManageCustomHTMLIntegrations',
  CAN_SET_PUBLIC_PAGE_PASSWORD = 'canSetPublicPagePassword',
  CAN_MANAGE_PERMISSIONS = 'canManagePermissions',
  CAN_INVITE_GUESTS = 'canInviteGuests',
  CAN_MANAGE_BILLING = 'canManageBilling',
  CAN_CHANGE_ORG_OWNER = 'canChangeOrgOwner',
  CAN_UPDATE_ORG = 'canUpdateOrg',
  CAN_MANAGE_DOMAIN = 'canManageDomain',
  CAN_MANAGE_SMTP = 'canManageSMTP',
  CAN_PURCHASE_ADDONS = 'canPurchaseAddons',
  CAN_ACCESS_BLOT_LOCKING = 'canAccessBlotLocking',
  CAN_ACCESS_WEBNOTES = 'canAccessWebnotes',
  CAN_CREATE_PORTAL = 'canCreatePortal',
  CAN_EXPORT_PDF = 'canExportPDF',
  CAN_MANAGE_AUTOMATION = 'canManageAutomation',
  CAN_MANAGE_AGENTS = 'canManageAgents',
}
